import Vue from 'vue'
import Vuex from 'vuex'

export default class {
	constructor() {
		Vue.use(Vuex);
		const state = {
			searchTerm: '',
			sortProperty: null,
			contactMasterList: null,
			contactsDisplayList: null,
		};
		const getters = {
      searchTerm: state => state.searchTerm,
      sortProperty: state => state.sortProperty,
      contactsDisplayList: state => state.contactsDisplayList,
		};
		const mutations = {
			setStateValue(state, [key, value]) {
				state[key] = value;
			},
			sortContacts(state, sortProperty) {
				let sortedContacts = state.contactsDisplayList.toSorted((a, b) => {
					if (!a[sortProperty] && !b[sortProperty]) return 0;
					if (!b[sortProperty]) return -1;
					if (!a[sortProperty]) return 1;
					if (a[sortProperty] < b[sortProperty]) return -1;
					if (a[sortProperty] > b[sortProperty]) return 1;
					return 0;
				});
				state.contactsDisplayList = sortedContacts;
			},
			filterContacts(state, searchTerm) {
				if (!searchTerm || searchTerm.trim() == "") state.contactsDisplayList = state.contactMasterList;
				let filteredContacts = state.contactMasterList.filter(contact => {
					for (const [key, value] of Object.entries(contact)) {
						if (!!value && value.toString().toLowerCase().includes(searchTerm)) return true;
					}
				});
				state.contactsDisplayList = filteredContacts;
			},
		};
		const actions = {};

		this.store = new Vuex.Store({
			state,
			getters,
			mutations,
			actions
		});
	}
}
